export const LOGGED_OUT_NAV_HEIGHT_PX = 84;
export const LOGGED_OUT_NAV_HEIGHT = `${LOGGED_OUT_NAV_HEIGHT_PX}px`;
